import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareAuthHeaders } from '../../utils/prepareAuthHeaders';

export const virtualGroupApi = createApi({
    reducerPath: 'virtualGroupApi',
    keepUnusedDataFor: 1,
    baseQuery: fetchBaseQuery({
        baseUrl: '/VirtualGroup',
        prepareHeaders: prepareAuthHeaders,
    }),
    endpoints: (builder) => ({
        saveVirtualGroup: builder.mutation({
            query: ({ data }) => ({
                url: `/SaveVirtualGroup`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Post'],
        }),
        getVirtualGroups: builder.query({
            query: () => ({
                url: `/GetVirtualGroups`,
                method: 'GET'
            })
        }),
        removeVirtualGroup: builder.mutation({
            query: ({ data }) => ({
                url: `/RemoveVirtualGroup`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Post'],
        }),
        virtualGroupDetails: builder.query({
            query: (virtualGroupId) => ({
                url: `/VirtualGroupDetails`,
                method: 'GET',
                params: {virtualGroupId}
            })
        }),
        editVirtualGroup: builder.mutation({
            query: ({ data }) => ({
                url: `/EditVirtualGroup`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Post'],
        }),
        addStudentToVirtualGroup: builder.mutation({
            query: ({ data }) => ({
                url: `/AddStudentToVirtualGroup`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Post'],
        }),
    }),
});

export const {
    useSaveVirtualGroupMutation,
    useGetVirtualGroupsQuery,
    useRemoveVirtualGroupMutation,
    useVirtualGroupDetailsQuery,
    useEditVirtualGroupMutation,
    useAddStudentToVirtualGroupMutation
} = virtualGroupApi;
